import { Bank } from '@features/accounts/types/bank';
import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { ToastUtility } from '@utils';
import { AxiosResponse } from 'axios';

export type GetBanksResponse = {
  savings: Bank[];
  checking: Bank[];
};

export async function getBanks(): Promise<GetBanksResponse> {
  return await api
    .get(`/api/v3/user/banks`)
    .then((res: AxiosResponse<GetBanksResponse>) => res.data);
}

export const getBanksQueryOptions = queryOptions({
  queryKey: ['banks', 'list'],
  queryFn: getBanks,
});

type UseGetBanksOptions = {
  queryConfig?: QueryConfig<typeof getBanksQueryOptions>;
};

export const useGetBanks = ({ queryConfig }: UseGetBanksOptions = {}) => {
  return useQuery({ ...getBanksQueryOptions, ...queryConfig });
};

export const callGetBanksErrorToast = () => {
  ToastUtility.error('Failed to fetch Banks', { toastId: 'banks' });
};
